import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import {HupSubscriptionsService} from '../../data/services/hup-subscriptions.service';
import {TranslationService} from '../../core/services/translation.service';
import {SubChangeService} from '../../data/services/sub-change.service';
import {HupSubscription} from '../../data/models/subscription.model';
import {SubChange} from '../../data/models/sub-change.model';
import {NavigationCommand, NavigationService} from '../../data/services/navigation.service';
import { DatePipe } from "@angular/common";
import {LoadingSpinnerComponent} from "../../core/components/loading-spinner/loading-spinner.component";
import {GeneralErrorsComponent} from "../../core/components/general-errors/general-errors.component";
import {MatCard, MatCardActions, MatCardContent, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {HouseNoPipe} from "../../core/pipes/houseno.pipe";
import {MatButton} from "@angular/material/button";
import {
  MatAccordion,
  MatExpansionPanel, MatExpansionPanelActionRow, MatExpansionPanelContent,
  MatExpansionPanelDescription, MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {AddressDetailComponent} from "../../core/components/address-detail/address-detail.component";
import { OnlinePaymentChecker} from "../../core/components/utils/online-payment-checker";
import {ApplyIfNotEmptyDirective} from "../../core/directives/apply-if-not-empty.directive";
import {ConfigService} from "../../core/services/config.service";
import {isDigital} from "../../core/utils/offer-utils";
import {BaseDataService} from "../../core/services/base-data.service";


@Component({
  selector: 'app-sub-change',
  templateUrl: './sub-change.component.html',
  styleUrls: ['./sub-change.component.scss'],
  imports: [
    LoadingSpinnerComponent,
    GeneralErrorsComponent,
    MatCard,
    MatCardTitle,
    MatCardSubtitle,
    DatePipe,
    HouseNoPipe,
    MatCardActions,
    MatButton,
    MatCardContent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatExpansionPanelContent,
    AddressDetailComponent,
    MatExpansionPanelActionRow,
    ApplyIfNotEmptyDirective
  ],
  providers: [
    DatePipe
  ],
  standalone: true
})
export class SubChangeComponent implements OnInit {
  private subChangeService = inject(SubChangeService);
  private hupSubscriptionsService = inject(HupSubscriptionsService);
  translationService = inject(TranslationService);
  private navigationService = inject(NavigationService);
  private configService = inject(ConfigService);
  private baseDataService = inject(BaseDataService);

  private onlinePaymentChecker: OnlinePaymentChecker = new OnlinePaymentChecker();

  isLoadingSub: boolean = false;
  subs: HupSubscription[] = [];
  errorsArr: string[] = [];
  foundDigitalSubscription: boolean = false;

  ngOnInit(): void {
    this.isLoadingSub = true;

    const onlinePaymentConfig = this.configService.getConfig(this.onlinePaymentChecker.ONLINE_PAYMENT_METHOD_ID_CONFIG_KEY);
    if (onlinePaymentConfig && onlinePaymentConfig.value) {
      this.onlinePaymentChecker.setPaymentCode(onlinePaymentConfig.value);
    }

    this.hupSubscriptionsService.getSubscriptions().subscribe(subs => {
      this.isLoadingSub = false;
      this.foundDigitalSubscription = false;
      this.subs = [];
      subs.forEach(sub => {
        if ((sub.validDate.validUntil == null || sub.validDate.validUntil > new Date()) && sub.backendId > 0) {
          if (!isDigital(sub.offer?.offerType) && !isDigital(sub.subscriptionType)) {
            this.subs.push(sub);
          } else {
            this.foundDigitalSubscription = true;
          }
        }
      });
      this.subs.forEach(sub => {
        sub.isLoadingSubChange = true;

        this.subChangeService.getSubChanges(sub.backendId, -1, true).subscribe({
          next: (res) => {
            sub.subChanges = res;
            sub.subChanges.forEach(s => {
              this.baseDataService.handlePerson(s.person);
              this.baseDataService.handleAddress(s.address);
            })
            },
          error: (error) => {
            sub.isLoadingSubChange = false;
            this.errorsArr.push(this.translationService.getTranslation('error_subchanges_init'));
            },
          complete: () => {
            sub.isLoadingSubChange = false;
            sub.subChanges.forEach(subChange => {
              subChange.outdated = new Date(subChange.validDate.validFrom).getTime() <= new Date().getTime();
            });
         }
        });
      });
    }, error => {
      this.isLoadingSub = false;
      this.errorsArr.push(this.translationService.getTranslation('error_subscription_init'));
    });
  }

  onDelete(sub: HupSubscription, subchange: SubChange): void{
    this.subChangeService.deleteSubChange(subchange.webId, sub.subId, subchange.backendId);
    this.hupSubscriptionsService.loadedAll = false;
    this.ngOnInit();
  }

  onNewSubChange(sub: HupSubscription): void {
    this.navigationService.navigateTo(NavigationCommand.SUBCHANGENEW, [sub.webId + '', sub.backendId + '']);
  }

  onEdit(sub: HupSubscription, subChange: SubChange): void{
    this.navigationService.navigateTo(NavigationCommand.SUBCHANGEEDIT, [subChange.webId + '', subChange.backendId + '', 'true', sub.backendId + '']);
  }

  isOnlinePayment(subscription: HupSubscription): boolean {
    return this.onlinePaymentChecker.isOnlinePayment(subscription.curPayment);
  }
}
